import { api } from './axiosConfig';



// order api
export const addItemToOrder = (itemId, orderId, quantity) =>
  api.post(`/orders/${itemId}/order/${orderId}/quantity/${quantity}`);
export const createOrder = (orderData) =>
  api.post('/orders', orderData);
export const getOrder = (id) => api.get(`/orders/${id}`);
export const updateOrder = (id, status) => api.put(`/orders/${id}/status`,null, {params:{status}});
export const filterOrdersByDate = (date, creatorId, status, page = 0, size = 10) => {
  const params = new URLSearchParams();
  const today = new Date().toISOString().split('T')[0];
  params.append('date', date || today);

  if (creatorId) params.append('creatorId', creatorId);
  if (status) params.append('status', status);
  params.append('page', page);
  params.append('size', size);

  return api.get(`/orders/filter-by-date?${params.toString()}`);
};


//bill api
export const createBillForOrder = (orderId) =>
  api.post(`/bills?orderId=${orderId}`);
export const getBillsPaginated = (page, size) =>
  api.get(`/bills?page=${page}&size=${size}`);

export const getTenBills = (id) =>
  api.get(`/bills/last-teen/table/${id}?page=0&size=10`);

export const applyDiscountToBill = (percent) =>
  api.post(`/bills/discount?percent=${percent}`);
export const printBill = (id) =>
  api.get(`/bills/print/${id}`);





// table api
export const getTableById = (id) => api.get(`/tables/${id}`);
export const putTableOccupied = (id) => api.put(`/tables/${id}/occupied`);
export const putTableFree = (id) => api.put(`/tables/${id}/free`);
export const getAllTabless = (page, size) =>
  api.get(`/tables?page=${page}&size=${size}`);

// menu api
export const getCategoryById = (id) => api.get(`/menu/${id}`);
export const getAllCategories = (page, size, token) =>
  api.get(`/categories?page=${page}&size=${size}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });


// Auth Controller
export const signUp = (data) => api.post(`auth/signup`, data);
export const signIn = (data) => api.post(`auth/signin`, data);
export const forgetPassword = (email) => api.post(`/users/forgot-password?email=${encodeURIComponent(email)}`);
export const resetPassword = (token, newPassword) => api.post(`/users/reset-password?token=${encodeURIComponent(token)}&newPassword=${encodeURIComponent(newPassword)}`);
export const verifyEmail = (token) => api.get(`/users/verify?token=${encodeURIComponent(token)}`);
export const resendVerificationToken = (email) => api.post(`/users/resend?email=${encodeURIComponent(email)}`);


//contact 
export const sendMessage = (data) =>  api.post('/api/contact', data);